module.exports = __webpack_public_path__ + "assets/img/12_145_big.4921afbe.jpg";